// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-CustomModal-CustomModal-module__modalWrapper {
  width: 100%;
}
.src-shared-components-CustomModal-CustomModal-module__modalWrapper .src-shared-components-CustomModal-CustomModal-module__btnWrapper {
  width: 100%;
}

.src-shared-components-CustomModal-CustomModal-module__modalContent {
  height: 100%;
  row-gap: var(--space-s);
  align-items: center;
  flex-direction: column;
}

.src-shared-components-CustomModal-CustomModal-module__modal {
  display: flex;
  padding: var(--space-s);
  flex-direction: column;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/CustomModal/CustomModal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AAAF","sourcesContent":[".modalWrapper {\n  width: 100%;\n  \n  .btnWrapper {\n    width: 100%;\n  }\n}\n\n.modalContent {\n  height: 100%;\n  row-gap: var(--space-s);\n  align-items: center;\n  flex-direction: column;\n}\n\n.modal {\n  display: flex;\n  padding: var(--space-s);\n  flex-direction: column;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `src-shared-components-CustomModal-CustomModal-module__modalWrapper`,
	"btnWrapper": `src-shared-components-CustomModal-CustomModal-module__btnWrapper`,
	"modalContent": `src-shared-components-CustomModal-CustomModal-module__modalContent`,
	"modal": `src-shared-components-CustomModal-CustomModal-module__modal`
};
export default ___CSS_LOADER_EXPORT___;
